import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { BOTTOM_BAR_HEIGHT } from '@xing-com/crate-jobs-constants';
import {
  useBreakpoints,
  useSearchAlerts,
  useSearchAlertRequiredFields,
} from '@xing-com/crate-jobs-hooks';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

import { SearchAlertBannerIcon } from './search-alert-banner-icon';
import { SearchAlertBannerText } from './search-alert-banner-text';

const Banner: React.FC<PropsWithChildren> = ({ children }) => {
  const { isMediaSmallOrTiny } = useBreakpoints();
  const { loading: isLoading } = useSearchAlerts();
  const { keywords, location } = useSearchAlertRequiredFields();

  // Since the banner is not needed for SSR, it is safe to use the
  // useBreakpoints hook
  if (isMediaSmallOrTiny) {
    return null;
  }

  const isShown = !isLoading && !!(keywords || location);

  return (
    <StyledBanner
      data-testid="jobs-search-alert-banner"
      show={isShown}
      display="fixed"
    >
      {children}
    </StyledBanner>
  );
};

export const SearchAlertBanner: React.FC = () => {
  return (
    <Banner>
      <SearchAlertBannerIcon />
      <SearchAlertBannerText />
    </Banner>
  );
};

const StyledBanner = styled(ContentBanner)`
  padding: ${spaceL};
  min-height: ${BOTTOM_BAR_HEIGHT}px;
  display: none;

  @media ${mediaConfined} {
    justify-content: center;
    display: flex;
  }
`;
